import React, { useEffect, useState } from 'react';
import Switch from "react-switch";
import { Form, FormFeedback, Input } from 'reactstrap';
import { Offsymbol, OnSymbol } from '../../../constants/holcim';
import { BaseCustomModal, GradientDecorationLine, BaseCustomButton } from '../../../shared';

// Formik formikFormData
import { useFormik } from "formik";
import * as Yup from "yup";

export const LocationRegisterModal = ({ setShowModal, showModal, modalRespInfo, isUpdate, rowInfo, modalClose }) => {

    const [active, setActive] = useState(false);
    const [lockActive, setLockActive] = useState(false);

    useEffect(() => {
        if (isUpdate) {
            setActive(rowInfo.recordStatus);
            setLockActive(false);
        } else {
            setActive(true);
            setLockActive(true);
        }
    }, [showModal]);

    const formikFormData = useFormik({
        enableReinitialize: true,
        initialValues: { name: isUpdate ? rowInfo.name : '' },
        validationSchema: Yup.object({ name: Yup.string().required("Ingrese el nombre de la localidad") }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values, active);
            resetForm();
            setShowModal(false);
        }
    });

    const onClosed = () => {
        formikFormData.resetForm();
        modalClose();
        setShowModal(!showModal);
    }

    const children_form = (
        <div>
            <h4 className="text-primary m-0 ps-4">Registro/Actualización de Localidad</h4>
            <GradientDecorationLine />
            <Form onSubmit={formikFormData.handleSubmit}>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Nombre de la Región</label>
                    <Input
                        name="name"
                        className="form-control text-primary"
                        placeholder="Región"
                        {...formikFormData.getFieldProps('name')}
                        invalid={formikFormData.touched.name && !!formikFormData.errors.name}
                    />
                    {formikFormData.errors.name && <FormFeedback>{formikFormData.errors.name}</FormFeedback>}
                </div>
                <div className="px-5">
                    <div className='text-primary pb-2'>Activo</div>
                    <Switch
                        disabled={lockActive}
                        onChange={() => setActive(!active)}
                        checked={active}
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        onColor="#94C12E"
                    />
                </div>
                <GradientDecorationLine />
                <div className="page-title-box d-flex justify-content-end">
                    <BaseCustomButton
                        outline
                        color="primary"
                        className='mx-4'
                        onClick={formikFormData.handleSubmit}
                        icon='mdi mdi-content-save me-1'
                        label='Guardar'
                    />
                    <BaseCustomButton
                        outline
                        color="danger"
                        onClick={onClosed}
                        icon='mdi mdi-close-circle-outline me-1'
                        label='Cancelar'
                    />
                </div>
            </Form>
        </div>
    );

    return (
        <>
            <BaseCustomModal
                isModalOpen={showModal}
                handleCancel={onClosed}
                handleOk={onClosed}
                footer={null}
                children={children_form}
                width={700}
            />;
        </>
    )
};
